import type { FlattenSimpleInterpolation } from "styled-components"
import styled from "styled-components"

export * from "./side-nav"
export * from "./header"
export * from "./footer"
export * from "./textInput"

export const Container = styled.nav<{ css?: FlattenSimpleInterpolation }>`
  ${({ css }) => css}
`
